export const encodeBase64UrlSave = (string: Buffer): string => {
    return string.toString('base64').replace('/', '_');
};

export const decodeBase64UrlSave = (string: string): string => {
    return atob(string.replace('_', '/'));
};
